(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/single-rows-container.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/single-rows-container.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  focusElement
} = svs.numbergames.core.utils.ui;
svs.numbergames.game.views.SingleRowsContainer = Marionette.View.extend({
  className: 'numbergames-single-rows-container',
  regions: {
    singleRowsHeaderRegion: '#singleRowsHeaderRegion',
    singleRowsRegion: '#singleRowsRegion'
  },
  ui: {
    singleRows: '.js-numbergames-keyboard-nav'
  },
  modelEvents: {
    'change:numberOfValidBoards': 'renderHeader',
    'change:rowPriceMulti': 'onChangeRowPriceMulti'
  },
  behaviors: [{
    behaviorClass: svs.numbergames.accessibility.behaviors.KeyboardNavigation
  }],
  template() {
    return "\n        <div id=\"singleRowsHeaderRegion\"></div>\n        <div id=\"singleRowsRegion\" class=\"js-numbergames-keyboard-nav\" tabindex=\"0\" aria-labelledby=\"singleRowsHeaderRegion\"></div>";
  },
  onRender() {
    this.showChildView('singleRowsHeaderRegion', {
      model: this.model,
      tagName: 'h3',
      className: 'numbergames-single-rows-title margin-bottom-1 f-600',
      template: _ref => {
        let {
          numberOfValidBoards
        } = _ref;
        return numberOfValidBoards > 1 ? "Mina ".concat(numberOfValidBoards, " rader") : 'Min rad';
      }
    });
    const productId = this.model.get('productId');
    const childOptions = {
      multipliedRowPrice: this.model.get('rowPrice') * this.model.get('rowPriceMulti'),
      ballRowBranding: svs.numbergames.productMapping.getProductName(productId),
      ballRowSize: this.getOption('ballRowSize')
    };
    this.showChildView('singleRowsRegion', new svs.numbergames.game.views.SingleRows({
      collection: this.model.get('boards'),
      childViewOptions(model, index) {
        return _objectSpread({
          rowIndex: index + 1
        }, childOptions);
      }
    }));
  },
  renderHeader() {
    this.getChildView('singleRowsHeaderRegion').render();
  },
  onChangeRowPriceMulti() {
    const multipliedRowPrice = this.model.get('rowPrice') * this.model.get('rowPriceMulti');
    this.getChildView('singleRowsRegion').triggerMethod('changeRowPriceMulti', multipliedRowPrice);
  },
  onArrowKeyNavigation(event) {
    this.getChildView('singleRowsRegion').triggerMethod('arrowKeyNavigation', event);
  },
  onActivateTabNavigation(event) {
    this.getChildView('singleRowsRegion').triggerMethod('activateTabNavigation', event);
  },
  onInactivateTabNavigation(event) {
    this.getChildView('singleRowsRegion').triggerMethod('inactivateTabNavigation', event);
    focusElement(this.getUI('singleRows'));
  }
});

 })(window);